import { useEffect } from "react"
import { useAppDispatch } from "store"
import { ITheme, setTheme, THEME } from "store/slices/appSlice"
import { ExpeditionType } from "store/apis/expeditionsAPI/types"
import { useGetAllExpeditionsQuery } from "store/apis/expeditionsAPI"

const EVENT_EXPEDITION_THEME: Partial<Record<ExpeditionType, ITheme>> = {
  summer_expedition: THEME.SUMMER,
  love_day_expedition: THEME.CUPID,
  winter_expedition: THEME.WINTER
}

export const useEventTheme = () => {
  const dispatch = useAppDispatch()
  const { data: expeditionsList } = useGetAllExpeditionsQuery()

  useEffect(() => {
    if (!expeditionsList) return

    const activeEvent = expeditionsList.find((e) => e.isAvailable && e.eventId)
    const nextTheme = activeEvent?.title
      ? (EVENT_EXPEDITION_THEME[activeEvent.title] ?? THEME.COMMON)
      : THEME.COMMON

    dispatch(setTheme(nextTheme))
  }, [expeditionsList])
}
